export default __webpack_public_path__ + "static/media/ionic-md-text.f70401e5.svg";